module.exports = __webpack_public_path__ + "static/favicon192-4600ce4d68b5e05056fedac59b6d16ba.png";